import React, {useCallback, useEffect, useRef, useState} from "react";
import {useForm} from "react-hook-form";
import {toast} from "react-toastify";
import {addDays, eachDayOfInterval, format, parseISO} from "date-fns";

import LoadingEffect from "../../components/LoadingEffect";
import {Button, OperationButton} from "../../styles-components/Buttons";
import {Container} from "../../styles-components/Container";
import {
  Column,
  ErrorMessage,
  Form,
  FormHeader,
  InfoMessage,
  InputDate,
  Label,
  Row,
  RowDetailsTotal,
  RowOption,
  RowSpecific,
  RowValueButtons,
} from "../../styles-components/FormItens";

import {apiPedidos, apiCostCenters} from "../../services/data";
import inputFormat from "../../utils/inputFormat";
import DateVerifyValidate from "../../utils/DateVerifyValidate";
import UseRedirectView from "../../utils/UseRedirectView";

const FormPedidos = () => {


  const state = {
    orderTotal: 0
  }

  const [dataApi, setDataApi] = useState({});
  const [periodDates, setPeriodDates] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSmallView, setIsSmallView] = useState(false);
  const [isShowButton, setIsShowButton] = useState(false);
  const [dateDisabled, setDateDisabled] = useState(true);
  const [disabledInsertAs, setDisabledInsertAs] = useState(false);
  const [showTime, setShowTime] = useState(false);
  const [inputDisaled, setInputDisabled] = useState(false);
  const [minDateStart, setMinDateStart] = useState(
    format(new Date(), "yyyy-MM-dd")
  );
  const [minDateEnd, setMinDateEnd] = useState(
    format(new Date(), "yyyy-MM-dd")
  );

  const buttonSubmit = useRef(null);


  var notAvailableDates = [];


  const {
    register,
    formState: {errors},
    handleSubmit,
    setValue,
    getValues,
    watch,
    clearErrors,
    setError,
  } = useForm();

  const [
    watchIsEspecific,
    watchInsertAs,
    watchDateStart,
    watchDateEnd,
    watchTime,
    watchService,
  ] = watch([
    "is_especific",
    "insert_as",
    "date_start",
    "date_end",
    "time",
    "service_id",
  ]);

  useEffect(() => {
    setIsLoading(true);
    fetchData();
    if (window.innerWidth <= 570) {
      setIsSmallView(true);
    }
  }, []);

  useEffect(() => {
    if (watchDateStart !== "" && watchDateStart !== undefined) {
      clearErrors("date_start");
      if (getValues("service_id") != 47) {
        setIsShowButton(true);
        var validation = DateVerifyValidate.handleAvailableDateEntry(
          parseISO(watchDateStart),
          parseInt(watchService),
          new Date()
        );

        if (validation.error) {
          setIsShowButton(false);
          toast.error(validation.message, {toastId: validation.type});
          setError("date_start", {shouldFocus: true});
        }
      }
      if (getValues("insert_as") === "unico") {
        setValue("date_end", getValues("date_start"));
      } else {
        if (getValues("date_end") === "") {
          setValue(
            "date_end",
            format(addDays(parseISO(getValues("date_start")), +1), "yyyy-MM-dd")
          );
        }
      }
    }
  }, [watchDateStart]);

  useEffect(() => {
    if (watchTime !== "" && watchTime !== undefined) {
      clearErrors("time");

      if (getValues("service_id") === 47) {
        setIsShowButton(true);
        var validation = DateVerifyValidate.handleAvailableDateEntry(
          parseISO(watchDateStart),
          parseInt(watchService),
          new Date(),
          watchTime
        );

        if (validation.error) {
          setIsShowButton(false);
          toast.error(validation.message, {toastId: validation.type});
          setError("time", {shouldFocus: true});
        }
      }
    }
  }, [watchTime]);

  useEffect(() => {
    if (watchInsertAs !== "" && watchInsertAs !== undefined) {
      if (watchInsertAs === "periodo") {
        setDateDisabled((prev) => !prev);
        setValue("date_start", "");
        setValue("date_end", "");
        setMinDateEnd(
          format(addDays(parseISO(minDateStart), +1), "yyyy-MM-dd")
        );
      } else {
        setDateDisabled(true);
        if (
          getValues("date_start") !== "" &&
          getValues("date_start") !== undefined
        ) {
          setValue("date_end", getValues("date_start"));
        }
      }
    }
  }, [watchInsertAs]);

  useEffect(() => {
    if (watchService !== "" && watchService !== undefined) {
      if (getValues("date_start") !== "" || getValues("date_end") !== "") {
        setValue("date_start", "");
        setValue("date_end", "");
        setPeriodDates([]);
      }

      if (watchService === "47") {
        setShowTime(true);
        setDisabledInsertAs(true);
        setValue("insert_as", "unico");
      } else {
        setShowTime(false);
        setDisabledInsertAs(false);
      }
    }
  }, [watchService]);

  useEffect(() => {
    if (watchIsEspecific !== "" && watchIsEspecific !== undefined) {
      let aux = getValues("is_especific");
      setInputDisabled(getValues("is_especific"));
      if (aux) {
        setValue("total", 0);
      }
    }
  }, [watchIsEspecific, setInputDisabled, getValues, setValue]);

  const fetchData = async () => {
    await apiPedidos.index().then((response) => {
      response.data.data.services.sort(function (a, b) {
        return a.service.nome > b.service.nome
          ? 1
          : b.service.nome > a.service.nome
            ? -1
            : 0;
      });
      setDataApi(response.data.data);
    });
    setIsLoading(false);
  };

  const handleUpdateValueCenter = useCallback(
    (idInput, operator) => {
      switch (operator) {
        case "+":
          if (getValues(idInput) === "") setValue(idInput, parseInt(1));
          else setValue(idInput, parseInt(getValues(idInput)) + 1);
          break;

        case "-":
          if (getValues(idInput) === "") setValue(idInput, parseInt(-1));
          else setValue(idInput, parseInt(getValues(idInput)) - 1);
          break;
      }
    },
    [setValue, getValues]
  );

  const handleUpdateValueTotal = () =>(
     setValue('total', document.getElementById('total').value)
  );

  const handleUpdateTotolPerFactory = (e) =>{
    setValue(e.target.id, e.target.value)
  }

  const handleUpdateValueCoffee = useCallback(
    (coffee, operator) => {
      switch (operator) {
        case "+":
          setValue(coffee, getValues(coffee) + 1);
          break;

        case "-":
          setValue(coffee, getValues(coffee) - 1);
          break;
      }
    },
    [setValue, getValues]
  );

  const handleFocus = (event) => {
    event.target.select();
  };


  const generateListPeriod = (date_start, date_end) => {
    var aux = eachDayOfInterval({
      start: parseISO(date_start),
      end: parseISO(date_end),
    });

    var dates = [];
    var validation = {};

    aux.map((date) => {
      validation = DateVerifyValidate.handleAvailableDateEntry(
        date,
        parseInt(watchService),
        new Date()
      );
      if (validation.error) {
        return (notAvailableDates = [
          ...notAvailableDates,
          format(date, "dd/MM/yyyy"),
        ]);
      } else {
        return (dates = [...dates, format(date, "yyyy-MM-dd")]);
      }
    });

    return dates;
  };


  const sunTotal = event => {
    let ammount = 0;
    dataApi.cost_centers.map((constCenter, key) => {
      let inputValue = document.getElementById('empresa' + key).value;
      if (inputValue && !isNaN(inputValue)) {
        ammount += parseInt(inputValue);
        state.orderTotal = ammount;
      }
    })
    document.getElementById('total').value = state.orderTotal;
  }


  const onSubmit = async (data) => {

    var requestData = {
      date_start: data.date_start,
      date_end: data.date_end,
      insert_as: data.insert_as,
      service_id: parseInt(data.service_id),
      note: data.note,
      // cost_centers_has_percentage: data.cost_centers_has_percentage,
    };


    if (data?.time && requestData.service_id === 47) {
      requestData.time = data.time;
    }

    if (data?.coffee_litro_1 && requestData.service_id === 2) {
      requestData.coffee_litro_1 = data.coffee_litro_1;
    } else {
      requestData.total = data.total;
    }

    if (requestData.insert_as === "periodo") {
      requestData = {
        ...requestData,
        is_especific: data.is_especific,
      };

      requestData.available_dates = generateListPeriod(
        data.date_start,
        data.date_end
      );



      if (requestData.is_especific) {
        requestData.totals_list = [];
        dataApi.cost_centers.map((item, key) => {
          if (item.name !== "") {
            requestData.totals_list.push({
              id: item.id,
              value: data['empresa'+key],
            });
          }
        });
      }
    } else {
      requestData = {
        ...requestData,
        is_especific: data.is_especific,
      };

      if (requestData.is_especific) {

        requestData.totals_list = [];
        dataApi.cost_centers.map((item,key) => {
          if (item.name !== "") {
            requestData.totals_list.push({
              id: item.id,
              value: data['empresa'+key],
            });
          }
        });

      }
    }



    if (notAvailableDates.length > 0) {
      var datesMessage = notAvailableDates.join("\n");
      if (
        window.confirm(
          `Estas datas não serão inseridas pois não respeitam as regras de antecedência:\n${datesMessage}`
        )
      ) {
        try {
          await apiPedidos.store(requestData).then((response) => {
            if (response.data.data && response.data.data.error) {
              toast.error(response.data.data.message);
            } else {
              toast.success("O pedido foi cadastrado com sucesso!");
              UseRedirectView.to("pedidos/listagem");
            }
          });
        } catch (error) {
          toast.error("Algo deu errado ao cadastrar o pedido.");
        }
      }
    } else {
      try {
        await apiPedidos.store(requestData).then((response) => {
          if (response.data.data && response.data.data.error) {
            toast.error(response.data.data.message);
          } else {
            toast.success("O pedido foi cadastrado com sucesso!");
            UseRedirectView.to("pedidos/listagem");
          }
        });
      } catch (error) {
        toast.error("Algo deu errado ao cadastrar o pedido.");
      }
    }

  };



  return (
    <>
      {isLoading ? (
        <LoadingEffect/>
      ) : (
        <Container>
          <FormHeader>
            <h1>Cadastro de Pedidos</h1>
            <Button
              color="--white"
              backgroundColor="--orange"
              onClick={() => UseRedirectView.to("pedidos/listagem")}
            >
              Voltar
            </Button>
          </FormHeader>
          <Form method="POST" onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Label>Serviço:</Label>
              <select
                {...register("service_id", {
                  required: {
                    value: true,
                    message: "O tipo do serviço é obrigatório!",
                  },
                })}
                style={errors.service_id && {...inputFormat}}
              >
                <option></option>
                {dataApi.services?.map((item) => (
                  <option key={item.service_id} value={item.service.id}>
                    {item.service.nome}
                  </option>
                ))}
              </select>

            </Row>
            {errors?.service_id && (
              <ErrorMessage color="--red">
                {errors.service_id.message}
              </ErrorMessage>
            )}
            <Row>
              <Column>
                <Label>Deseja cadastrar:</Label>
                <RowOption isOptionRadio={true}>
                  <InputDate
                    {...register("insert_as")}
                    type="radio"
                    value="unico"
                    id="unico"
                    defaultChecked
                  />
                  <Label htmlFor="unico">apenas um dia</Label>
                </RowOption>
                <RowOption isOptionRadio={true}>
                  <InputDate
                    {...register("insert_as")}
                    value="periodo"
                    type="radio"
                    id="periodo"
                    disabled={disabledInsertAs}
                  />
                  <Label htmlFor="periodo">um período de dias</Label>
                </RowOption>
              </Column>
            </Row>
            <Row isDate={true}>
              <Label htmlFor="data-inicio">Data Inicial:</Label>
              <input
                {...register("date_start", {
                  required: {
                    value: true,
                    message: "A data inicial é obrigatória!",
                  },
                })}
                style={errors.date_start && {...inputFormat}}
                type="date"
                min={minDateStart}
                id="data-inicio"
              />
            </Row>
            {errors?.date_start && (
              <ErrorMessage color="--red">
                {errors.date_start.message}
              </ErrorMessage>
            )}
            <Row>
              <Label htmlFor="data-fim">Data Final:</Label>
              <input
                {...register("date_end", {
                  required: {
                    value: true,
                    message:
                      "Um período foi selecionado! É obrigatório a data final.",
                  },
                })}
                style={errors.date_end && {...inputFormat}}
                type="date"
                min={minDateEnd}
                disabled={dateDisabled}
                id="data-fim"
              />
            </Row>
            {errors?.date_end && (
              <ErrorMessage color="--red">
                {errors.date_end.message}
              </ErrorMessage>
            )}
            {showTime && (
              <>
                <Row>
                  <Label htmlFor="horario">Horário:</Label>
                  <input
                    {...register("time", {
                      required: {
                        value: true,
                        message:
                          "Para este serviço é obrigatório informar um horário.",
                      },
                    })}
                    style={errors.time && {...inputFormat}}
                    type="time"
                    id="horario"
                  />
                </Row>
                {errors?.time && (
                  <ErrorMessage color="--red">
                    {errors.time.message}
                  </ErrorMessage>
                )}
              </>
            )}



            {(
              <>
                {
                  dataApi.cost_centers.map((costCenter, index) => (
                    <RowDetailsTotal key={index}>
                      <Label htmlFor={costCenter.id}>{costCenter.name}</Label>
                      <input
                        id={'empresa' + index}
                        {...register('empresa' + index, {
                          value: 0,
                          required: {
                            value: true,
                            message: "Este item é obrigatório",
                          },
                          min: {
                            value: 0,
                            message: "A quantidade precisa ser maior ou igual a 0",
                          },
                        })}

                        key={index}
                        min="0"
                        style={errors['empresa'+index] && {...inputFormat}}
                        type="number"
                        onBlur={sunTotal}
                        onChange= {e=>{ sunTotal(e); handleUpdateValueTotal(); handleUpdateTotolPerFactory(e)}}
                        onFocus={handleFocus}

                      />
                    </RowDetailsTotal>

                  ))
                }

                <RowDetailsTotal>
                    <>
                      <Label htmlFor="total">Total:</Label>
                        <input
                          {...register("total", {
                            value: state.orderTotal,
                            required: {
                              value: true,
                              message: "Este item é obrigatório",
                            },
                            min: {
                              value: 1,
                              message: "A quantidade precisa ser maior que 0",
                            },
                          })}
                          style={errors.total && {...inputFormat}}
                          type="number"
                          id="total"
                          className={'form-control'}
                          readOnly={true}
                          onChange={handleUpdateValueTotal}
                        />

                      {errors?.total && (
                        <ErrorMessage color="--red">
                          {errors.total.message}
                        </ErrorMessage>
                      )}
                    </>

                  {watchService !== "8" && watchService !== "13" && (

                      <RowOption>
                        <div className='d-none'>
                          <input
                            {...register("is_especific")}
                            type="checkbox"
                            id="is_especific"
                            checked
                          />
                          <Label htmlFor="is_especific">
                            detalhar por centros de custo
                          </Label>
                        </div>
                      </RowOption>
                  )}

                </RowDetailsTotal>
         </>
            )}
            <Column>
              <Label htmlFor="note">Observação:</Label>
              <textarea {...register("note")} id="note"></textarea>
            </Column>
            {isShowButton && (
              <Button
                color="--white"
                backgroundColor="--orange"
                align="flex-end"
                ref={buttonSubmit}
              >
                Criar
              </Button>
            )}
          </Form>
        </Container>
      )}
    </>
  );
};

export default FormPedidos;
